(() => {
  const carouselSelector = '.mq-native-specs';
  const benefitsSelector = '.mq-native-benefits';
  let benefitsListCount = 0;

  function arrowIcon(direction) {
    const points = direction === 'previous' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
    return `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><polyline points="${points}" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline></svg>`;
  }

  function buildCarousel(items, type, label) {
    const carousel = document.createElement('div');
    carousel.className = `mq-specs-carousel mq-specs-carousel--${type}`;
    carousel.dataset.mqCarouselReady = 'true';

    const track = document.createElement('div');
    track.className = 'mq-specs-carousel__track';
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', label);

    const slides = items.map((item, index) => {
      const slide = document.createElement('div');
      slide.className = 'mq-specs-carousel__slide';
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-label', `${index + 1} de ${items.length}`);
      slide.hidden = index !== 0;
      slide.appendChild(item);
      track.appendChild(slide);
      return slide;
    });

    const navigation = document.createElement('div');
    navigation.className = 'mq-specs-carousel__nav';

    const previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'mq-specs-carousel__button mq-specs-carousel__button--previous';
    previous.setAttribute('aria-label', 'Ver ficha anterior');
    previous.innerHTML = arrowIcon('previous');

    const status = document.createElement('span');
    status.className = 'mq-specs-carousel__status';
    status.setAttribute('aria-live', 'polite');

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'mq-specs-carousel__button mq-specs-carousel__button--next';
    next.setAttribute('aria-label', 'Ver ficha siguiente');
    next.innerHTML = arrowIcon('next');

    navigation.append(previous, status, next);
    carousel.append(track, navigation);

    let activeIndex = 0;
    let touchStartX = null;

    const showSlide = (newIndex) => {
      activeIndex = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        slide.hidden = index !== activeIndex;
        slide.classList.toggle('is-entering', index === activeIndex);
      });
      status.textContent = `${activeIndex + 1} / ${slides.length}`;
    };

    previous.addEventListener('click', () => showSlide(activeIndex - 1));
    next.addEventListener('click', () => showSlide(activeIndex + 1));

    track.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) > 45) {
        showSlide(activeIndex + (distance < 0 ? 1 : -1));
      }
      touchStartX = null;
    }, { passive: true });

    showSlide(0);
    return carousel;
  }

  function enhanceTables(specs) {
    const richText = specs.querySelector('.mq-native-specs__text .metafield-rich_text_field');
    if (!richText || richText.dataset.mqTablesReady === 'true') return;

    const tables = Array.from(richText.children).filter((element) => element.tagName === 'TABLE');
    richText.dataset.mqTablesReady = 'true';
    if (tables.length < 2) return;

    const carousel = buildCarousel(tables, 'tables', 'Fichas técnicas del producto');
    richText.insertBefore(carousel, richText.firstChild);
  }

  function enhanceMedia(specs) {
    const media = specs.querySelector('.mq-native-specs__media');
    if (!media || media.dataset.mqMediaReady === 'true') return;

    const images = Array.from(media.children).filter((element) => element.classList.contains('mq-native-specs__image'));
    media.dataset.mqMediaReady = 'true';
    if (images.length < 2) return;

    media.appendChild(buildCarousel(images, 'media', 'Imágenes de las fichas técnicas'));
  }

  function enhanceBenefits(benefits) {
    const richText = benefits.querySelector('.metafield-rich_text_field');
    if (!richText || richText.dataset.mqBenefitsReady === 'true') return;

    const list = Array.from(richText.children).find((element) => ['UL', 'OL'].includes(element.tagName));
    richText.dataset.mqBenefitsReady = 'true';
    if (!list) return;

    const items = Array.from(list.children).filter((element) => element.tagName === 'LI');
    if (items.length <= 3) return;

    benefitsListCount += 1;
    if (!list.id) list.id = `MqBenefitsList-${benefitsListCount}`;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mq-benefits-toggle';
    button.setAttribute('aria-controls', list.id);

    const setExpanded = (expanded) => {
      items.slice(3).forEach((item) => {
        item.hidden = !expanded;
      });
      button.setAttribute('aria-expanded', String(expanded));
      button.innerHTML = `<span>${expanded ? 'Ver menos beneficios' : `Ver todos los beneficios (${items.length})`}</span><span class="mq-benefits-toggle__icon" aria-hidden="true"></span>`;
    };

    button.addEventListener('click', () => {
      setExpanded(button.getAttribute('aria-expanded') !== 'true');
    });

    richText.appendChild(button);
    setExpanded(false);
  }

  function initialize(root = document) {
    const sections = [];
    const benefitsSections = [];
    if (root.matches && root.matches(carouselSelector)) sections.push(root);
    if (root.matches && root.matches(benefitsSelector)) benefitsSections.push(root);
    if (root.querySelectorAll) {
      sections.push(...root.querySelectorAll(carouselSelector));
      benefitsSections.push(...root.querySelectorAll(benefitsSelector));
    }

    sections.forEach((specs) => {
      enhanceTables(specs);
      enhanceMedia(specs);
    });

    benefitsSections.forEach(enhanceBenefits);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
